export const REGISTER_GYM_USER_REQUEST = 'REGISTER_GYM_USER_REQUEST';
export const REGISTER_GYM_USER_SUCCESS = 'REGISTER_GYM_USER_SUCCESS';
export const REGISTER_GYM_USER_FAILED = 'REGISTER_GYM_USER_FAILED';

export const REGISTER_STANDARD_USER_REQUEST = 'REGISTER_STANDARD_USER_REQUEST';
export const REGISTER_STANDARD_USER_SUCCESS = 'REGISTER_STANDARD_USER_SUCCESS';
export const REGISTER_STANDARD_USER_FAILED = 'REGISTER_STANDARD_USER_FAILED';

export const UPLOADING_USER_AVATAR_PROCESS = 'UPLOADING_USER_AVATAR_PROCESS';
export const UPLOADING_USER_AVATAR_FINISHED = 'UPLOADING_USER_AVATAR_FINISHED';

export const SIGN_IN_USER_REQUEST = 'SIGN_IN_USER_REQUEST';
export const SIGN_IN_USER_SUCCESS = 'SIGN_IN_USER_SUCCESS';
export const SIGN_IN_USER_FAILED = 'SIGN_IN_USER_FAILED';

export const SIGN_OUT_USER_REQUEST = 'SIGN_OUT_USER_REQUEST';
export const SIGN_OUT_USER_SUCCESS = 'SIGN_OUT_USER_SUCCESS';
export const SIGN_OUT_USER_FAILED = 'SIGN_OUT_USER_FAILED';

export const SIGN_IN_USER_WITH_FACEBOOK_REQUEST = 'SIGN_IN_USER_WITH_FACEBOOK_REQUEST';
export const SIGN_IN_USER_WITH_FACEBOOK_SUCCESS = 'SIGN_IN_USER_WITH_FACEBOOK_SUCCESS';
export const SIGN_IN_USER_WITH_FACEBOOK_FAILED = 'SIGN_IN_USER_WITH_FACEBOOK_FAILED';

export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILED = 'FORGOT_PASSWORD_FAILED';

export const GET_AUTHENTICATED_USER_PREFERENCES_REQUEST = 'GET_AUTHENTICATED_USER_PREFERENCES_REQUEST';
export const GET_AUTHENTICATED_USER_PREFERENCES_SUCCESS = 'GET_AUTHENTICATED_USER_PREFERENCES_SUCCESS';
export const GET_AUTHENTICATED_USER_PREFERENCES_FAILED = 'GET_AUTHENTICATED_USER_PREFERENCES_FAILED';

export const GET_AUTHENTICATED_USER_REQUEST = 'GET_AUTHENTICATED_USER_REQUEST';
export const GET_AUTHENTICATED_USER_SUCCESS = 'GET_AUTHENTICATED_USER_SUCCESS';
export const GET_AUTHENTICATED_USER_FAILED = 'GET_AUTHENTICATED_USER_FAILED';

export const CLEAR_AUTHENTICATION_ERRORS = 'CLEAR_AUTHENTICATION_ERRORS';

export const DELETE_USER_ACCOUNT_REQUEST = 'DELETE_USER_ACCOUNT_REQUEST';
export const DELETE_USER_ACCOUNT_SUCCESS = 'DELETE_USER_ACCOUNT_SUCCESS';
export const DELETE_USER_ACCOUNT_FAILED = 'DELETE_USER_ACCOUNT_FAILED';



// WEBPACK FOOTER //
// ./src/Store/ActionTypes/UserActionTypes.js